var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0019 11.5C12.0697 11.5 13.7459 9.48528 13.7459 7C13.7459 4.51472 12.0697 2.5 10.0019 2.5C7.93409 2.5 6.25781 4.51472 6.25781 7C6.25781 9.48528 7.93409 11.5 10.0019 11.5Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3384 15.3249C16.6644 13.9749 15.3915 12.8499 13.7441 12.1749C13.2948 12.0249 12.7706 12.0249 12.3962 12.2499C11.6474 12.6999 10.8986 12.9249 10 12.9249C9.10142 12.9249 8.35261 12.6999 7.6038 12.2499C7.22939 12.0999 6.70522 12.0249 6.25593 12.2499C4.60854 12.9249 3.33556 14.0499 2.66163 15.3999C2.13746 16.3749 2.96115 17.4999 4.08437 17.4999H15.9156C17.0388 17.4999 17.8625 16.3749 17.3384 15.3249Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.ed9272eb1d3870e01274cc1f4deb480e.svg";
export { ForwardRef as ReactComponent };